import {Component, computed, signal, inject, effect} from '@angular/core';
import {AdsService} from "../services/ads.service";
import {MatIconModule} from "@angular/material/icon";
import {trigger, state, style, transition, animate} from '@angular/animations';
import {Ad} from "../models/ads.model";
import {UserService} from "../../../core/user/services/user.service";

@Component({
  selector: 'app-ads-dashboard',
  imports: [MatIconModule],
  templateUrl: './ads-dashboard.component.html',
  styleUrl: './ads-dashboard.component.scss',
  animations: [
    trigger('slideUpDown', [
      state('visible', style({
        transform: 'translateY(0)',
        opacity: 1
      })),
      state('hidden', style({
        transform: 'translateY(100%)',
        opacity: 0
      })),
      transition('visible <=> hidden', animate('300ms ease-in-out'))
    ])
  ]
})
export class AdsDashboardComponent {
  protected PHXCDN = inject('PHXCDN' as any) as string;
  protected adsService: AdsService = inject(AdsService);
  private readonly userService = inject(UserService);

  ads = computed(() => this.adsService.dashboardAds());
  hidden = signal(false);
  selected = signal<any>(null);

  constructor() {
    effect(() => {
      const allStickies = this.adsService.dashboardAds();

      if (allStickies.length === 0) {
        this.selected.set(null);
        return;
      }

      if (this.selected() !== null) return;

      const pool = this.buildPool(allStickies);
      const lastId = this.adsService.lastShownStickyId();

      let nextAd: Ad;

      if (lastId && pool.length > 1) {
        const candidates = pool.filter(a => a.id !== lastId);
        nextAd = candidates[Math.floor(Math.random() * candidates.length)];
      } else {
        nextAd = pool[Math.floor(Math.random() * pool.length)];
      }

      this.selected.set(nextAd);
      this.adsService.lastShownStickyId.set(nextAd.id);
    });
  }

  toggleBanner(): void {
    this.hidden.update((value: boolean) => !value);
  }

  private buildPool(allAds: Ad[]): Ad[] {
    if (this.userService.isAdmin()) return allAds;
    const prio = allAds.filter(a => a.prioritized);
    return prio.length > 0 ? prio : allAds;
  }
}
